import { gql, useQuery } from 'urql';

export const GET_EMPLOYEES_BY_DEPARTMENTS_QUERY = gql`
  query GetEmployeesByDepartments(
    $joinedAfter: FlexibleDateTime
    $joinedBefore: FlexibleDateTime
    $orderBy: ShowParticipantsBy
    $isRemote: Boolean
    $searchString: String
  ) {
    getEmployeesByDepartments(
      joinedAfter: $joinedAfter
      joinedBefore: $joinedBefore
      orderBy: $orderBy
      isRemote: $isRemote
      searchString: $searchString
    ) {
      id
      # uuid
      name
      active
      employees {
        id
        position
        firstName
        lastName
        active
        joinedAt
        leftAt
        isRemote
      }
      childDepartments {
        id
        # uuid
        name
        active
        employees {
          id
          position
          firstName
          lastName
          active
          joinedAt
          leftAt
          isRemote
        }
        childDepartments {
          id
          # uuid
          name
          active
          employees {
            id
            position
            firstName
            lastName
            active
            joinedAt
            leftAt
            isRemote
          }
          childDepartments {
            id
            # uuid
            name
            active
            employees {
              id
              position
              firstName
              lastName
              active
              joinedAt
              leftAt
              isRemote
            }
            childDepartments {
              id
              # uuid
              name
              active
              employees {
                id
                position
                firstName
                lastName
                active
                joinedAt
                leftAt
                isRemote
              }
            }
          }
        }
      }
    }
  }
`;

export interface Employee {
  id: number;
  position?: string;
  firstName: string;
  lastName: string;
  active: boolean;
  joinedAt?: string;
  leftAt?: string;
  isRemote: boolean;
}

export interface DepartmentNode {
  id: number;
  name: string;
  active: boolean;
  employees: Employee[];
  childDepartments: DepartmentNode[];
}

export interface GetEmployeesByDepartmentsResponse {
  getEmployeesByDepartments: DepartmentNode[];
}

export const useGetEmployeesByDepartments = (
  joinedAfter?: string,
  joinedBefore?: string,
  orderBy?: string,
  isRemote?: boolean,
  searchString?: string,
  pause?: boolean
) => {
  const trimmedSearch = searchString?.trim();
  const [result, reexecuteQuery] = useQuery<GetEmployeesByDepartmentsResponse>({
    query: GET_EMPLOYEES_BY_DEPARTMENTS_QUERY,
    variables: {
      joinedAfter,
      joinedBefore,
      orderBy,
      isRemote,
      searchString: trimmedSearch,
    },
    pause,
    requestPolicy: trimmedSearch ? 'network-only' : 'cache-first',
  });

  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    refetch: reexecuteQuery,
  };
};
